<template>
  <div
    style="
      background: var(--bg-secondary);
      padding-inline: 1rem;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    "
  >
    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <!-- <div class="nav-item" v-if="$store.state.wallet.connected">
        <router-link class="btn btn-primary" to="/village"
          ><img draggable="false" alt="" src="/img/vectors/x32/home.png" /> My
          Village</router-link
        >
      </div> -->
      <router-link
        class="navbar-brand me-0"
        :to="$store.state.wallet.connected ? '/village' : '/'"
      >
        <img
          draggable="false"
          src="/favicon.png"
          height="40"
          class="d-inline-block align-top"
          alt=""
        />
      </router-link>
      
      <div
        v-if="$store.state.wallet.connected"
        style="display: flex; gap: 20px"
      >
        <router-link to="/village/farm" class="text-center">
          <img
            draggable="false"
            title="Food"
            alt="Food"
            class="img-fluid"
            style="width: 20px"
            src="/img/sprite/resources/x32/wheat.png"
          />
          <h6 style="margin-bottom: 0px; font-size: 1rem" :title="fmtFull.format(resources.food)">
            {{ fmtK.format(resources.food) }}
          </h6>
        </router-link>
        <router-link to="/village/mine" class="text-center">
          <img
            draggable="false"
            title="Gold"
            alt="Gold"
            class="img-fluid"
            style="width: 20px"
            src="/img/sprite/resources/x32/gold.png"
          />
          <h6 style="margin-bottom: 0px; font-size: 1rem" :title="fmtFull.format(resources.gold)">
            {{ fmtK.format(resources.gold) }}
          </h6>
        </router-link>
        <router-link to="/village/mana" class="text-center">
          <img
            draggable="false"
            title="Mana"
            alt="Mana"
            class="img-fluid"
            style="width: 20px"
            src="/img/sprite/resources/x32/mana.png"
          />
          <h6 style="margin-bottom: 0px; font-size: 1rem" :title="fmtFull.format(resources.mana)">
            {{ fmtK.format(resources.mana) }}
          </h6>
        </router-link>
        <router-link to="/village/farm" class="text-center">
          <img
            draggable="false"
            title="Population"
            alt="Population"
            class="img-fluid"
            style="width: 20px"
            src="/img/sprite/resources/x32/population.png"
          />
          <h6 style="margin-bottom: 0px; font-size: 1rem" :title="`Available: ${availablePopulation} / Capacity: ${farmCapacity}`">
            {{ fmtK.format(availablePopulation) }}
          </h6>
        </router-link>
      </div>
    </div>

    <!-- <hr> -->

    <div style="display: flex; justify-content: end; align-items: center">
      <div class="village-switcher d-flex align-items-center my-2">
        <span
          v-if="hasMultipleVillages"
          class="village-arrow"
          @click="switchVillage(-1)"
          >&lsaquo;</span
        >
        <router-link to="/village"
          ><h6 class="d-inline mb-0">{{ villageName }}</h6></router-link
        >
        <span
          v-if="hasMultipleVillages"
          class="village-arrow"
          @click="switchVillage(1)"
          >&rsaquo;</span
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import store from "@/store";
import { computed } from "vue";
import { fmtK } from "@/types/utils";
import { calculateCurrentPopulation, calculateFarmCapacity } from "@/utils/population";

const fmtFull = new Intl.NumberFormat('en');

// computed
const activeVillage = computed(() => store.state.village.village);
const resources = computed<{
  food: number;
  mana: number;
  gold: number;
}>(() => {
  const resource = activeVillage.value?.resources;
  return {
    food: Math.max(0, resource?.food ?? 0),
    mana: Math.max(0, resource?.mana ?? 0),
    gold: Math.max(0, resource?.gold ?? 0),
  };
});
const currentPopulation = computed(() => calculateCurrentPopulation(activeVillage.value));
const farmCapacity = computed(() => calculateFarmCapacity(activeVillage.value));
const availablePopulation = computed(() => Math.max(0, farmCapacity.value - currentPopulation.value));
const hasMultipleVillages = computed<boolean>(
  () => store.state.user.villages && store.state.user.villages.length > 1,
);
const villageName = computed<string>(() => {
  if (activeVillage.value.name) {
    return store.state.user.client.toName(activeVillage.value.name);
  }

  const coords = activeVillage.value.position;
  if (!coords) return "??,??";

  return `X:${coords.x}, Y:${coords.y}`;
});
const sortedVillages = computed(() => {
  if (!store.state.user.villages) return [];
  // @ts-expect-error
  return store.state.user.villages.slice().sort((a, b) => {
    const nameA = store.state.user.client.toName(a.account.name);
    const nameB = store.state.user.client.toName(b.account.name);
    return nameA.localeCompare(nameB, undefined, {
      sensitivity: "base",
      numeric: true,
    });
  });
});

// methods
function switchVillage(direction: number) {
  const villages = sortedVillages.value;
  if (villages.length < 2) return;

  const activeKey = store.state.user.active_village;
  const currentIndex = villages.findIndex(
    (v: { publicKey: string }) =>
      v.publicKey.toString() === activeKey.toString(),
  );
  const nextIndex =
    (currentIndex + direction + villages.length) % villages.length;
  const village = villages[nextIndex];

  store.commit("user/set_active_village", village.publicKey);
  store.dispatch("village/refresh_village");
}
</script>

<style scoped>
.village-switcher {
  gap: 4px;
}
.village-arrow {
  cursor: pointer;
  font-size: 1.4rem;
  line-height: 1;
  color: var(--text-color-primary);
  opacity: 0.6;
  user-select: none;
  padding: 0 2px;
}

.village-arrow:hover {
  opacity: 1;
}
</style>
